import { Box, ButtonBase, Stack, Typography, useTheme } from '@mui/material'
import { grey } from '@mui/material/colors'
import { makeStyles } from '@mui/styles'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { BsTrash } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import Sale from '../../../../../../api/db/Sale'
import pubsub from '../../../../../../modules/pubsub'
import { selectCurrrentAdminShop } from '../../../../../../store/features/currentBusinessShop'
import { selectUserPropsState } from '../../../../../../store/features/user'
import Modal from '../../../../../molecules/Modal'
import BodySkeleton from '../../../../common/skeletons/BodySkeleton'

// import { getSalesHistory } from '../salesHistory'
import Loading from 'react-loading'
import Table from '../Table'

const tableHeadData=["Date", "Items sold","Total revenue(GH₵)", "Total profit(GH₵)", "Sold by",]

export default function ContentBody() {

    const theme = useTheme()
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [openedItem, setOpenedItem] = useState<{[key:string]:any}>({}) 
    const [isLoading, setIsLoading] = useState(false)
    const user_id = useSelector(selectUserPropsState)?.uid
    const current_shop = useSelector(selectCurrrentAdminShop)?.name
    const [salesHistory, setSalesHistory] = useState<any[]>([])
    
    useEffect(() => {
        
        pubsub.on("sales-history:changed", getSales)
        getSales()

        return ()=>pubsub.off("sales-history:changed", getSales)

      //eslint-disable-next-line
    }, [])


    const useStyles = makeStyles({
        content:{
            flex: 1, 
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            borderRadius: "4px", 
            minHeight: "420px", 
            backgroundColor: theme.palette.primary.main,
            padding: "1rem"
        },
        searchField:{
            backgroundColor: theme.palette.primary.dark,
            border: `.5px solid rgba(255, 255, 255, 0.1)`,
            padding: ".3rem",
            borderRadius: "3px",
            color: grey[200],
            fontWeight: "regular",
            fontSize: "14px",
            outline: "none"
        }
    })
    const classes = useStyles()

    const getSales = async()=>{

        try {
            setIsLoading(true)
            const res = await Sale.getSales(user_id!, current_shop!)
            setSalesHistory(res)
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            throw error
        }
        
    }
    
    return (
        <>

            {
                isLoading ? (
                    <BodySkeleton />
                ):(
                    <Box className={classes.content} >
                        <Stack
                            sx={{height: "100%"}}
                            direction="column"
                            spacing={2}
                        >

                            <Table 
                                title="Sales history"
                                tableHeadData={tableHeadData}
                                tableBodyData={salesHistory}
                                handleItemClick={(item)=>{
                                    setIsModalOpen(true)
                                    setOpenedItem(item)
                                }}
                            />

                        </Stack>
                    </Box>
                )
            }


            <Modal
                title=""
                subtitle={openedItem.id}
                visible={isModalOpen}
                setVisibility={setIsModalOpen}
            >
                <ModalContent setVisibility={setIsModalOpen} itemData={openedItem} />

            </Modal>
        </>
    )
}

const ModalContent = ({itemData, setVisibility}:{itemData:any, setVisibility: Dispatch<SetStateAction<boolean>>})=>{

    const [isLoading, setIsLoading] = useState(false)
    const user_id = useSelector(selectUserPropsState)?.uid
    const current_shop = useSelector(selectCurrrentAdminShop)?.name

    const handleOnDelete = async()=>{
        try {
            setIsLoading(true)
            await Sale.deleteSale(itemData.id, user_id,current_shop)
            setIsLoading(false)
            setVisibility(false)
            pubsub.trigger("sales-history:changed")
        } catch (error) {
            setIsLoading(false)
            toast("An error occurred during deletion please try later",{
                type: "error",
                theme: "dark",
                position: "top-center",
                hideProgressBar: true
            })
        }
    }

    return(

        <>
            <div className="w-full grid grid-flow-row grid-cols-3 my-8 text-secondary2">

                <div
                    className='border-b border-r bg-secondary/20 border-b-secondary/60 border-r-secondary/60 p-2'
                >
                    <span className='block text-secondary'>
                        {itemData.total_items_sold}
                    </span>
                    <Typography variant="subtitle2" color="grey.500" fontWeight={400}>
                        Total items sold
                    </Typography>
                </div>
                <div
                    className='border-b border-r bg-secondary/20 border-b-secondary/60 border-r-secondary/60 p-2'
                >
                    <span className="block text-secondary">GHC {itemData.total_revenue}</span>
                    <Typography variant="subtitle2" color="grey.500" fontWeight={400}>
                        Total revenue
                    </Typography>
                </div>
                <div
                    className='border-b bg-secondary/20 border-b-secondary/60 border-r-secondary/60 p-2'
                >
                    <span className="block text-secondary">GHC {itemData.total_profit}</span>
                    <Typography variant="subtitle2" color="grey.500" fontWeight={400}>
                        Total profit
                    </Typography>
                </div>
                <div
                    className='border-b bg-secondary/20 border-b-secondary/60 border-r border-r-secondary/60 p-2'
                >
                    <span className="block text-secondary">{`${itemData.meta_data.shopkeeper.first_name} ${itemData.meta_data.shopkeeper.last_name}`}</span>
                    <Typography variant="subtitle2" color="grey.500" fontWeight={400}>
                        Shopkeeper
                    </Typography>
                </div>
                <div
                    className='border-b bg-secondary/20 border-b-secondary/60 p-2'
                >
                    <span className="block text-secondary">{new Date(itemData.meta_data.created_at).toDateString()}</span>
                    <Typography variant="subtitle2" color="grey.500" fontWeight={400}>
                        Date
                    </Typography>
                </div>

            </div>

            <div className="w-full text-secondary2 h-36 overflow-auto">
                
                {/* table */}
                <table className="w-full block">

                    {/* Tablehead */}
                    <thead className='w-full block' >
                        <tr
                            className="w-full flex justify-center items-center text-left border-b-2 border-b-gray-600"
                        >
                            <th className='block flex-1 overflow-hidden'>
                                <p
                                    className='w-48 truncate overflow-hidden'
                                >
                                    Name
                                </p>
                            </th>
                            <th className='block flex-1 overflow-hidden'>
                                <p
                                    className='w-48 truncate overflow-hidden'
                                >
                                    No. Sold
                                </p>
                            </th>
                            <th className='block flex-1 overflow-hidden'>
                                <p
                                    className='w-48 truncate overflow-hidden'
                                >
                                    Revenue
                                </p>
                            </th>
                            <th className='block flex-1 overflow-hidden'>
                                <p
                                    className='w-48 truncate overflow-hidden'
                                >
                                    Profit
                                </p>
                            </th>
                        </tr>
                    </thead>

                    {/* tableBody */}
                    <tbody className='text-gray-400 block w-full'>
                        {
                            itemData?.in_cart.map((item:any, index:number)=>(
                                <tr 
                                    key={index} 
                                    className=' py-4 w-full flex justify-center items-center text-left border-b border-b-white/20 focus:bg-blue-500/20 focus:outline-none'
                                >
                                    <td className='flex-1'>
                                        <p
                                                className='w-48 truncate overflow-hidden'
                                            >
                                                {item.productName}
                                        </p>
                                    </td>
                                    <td className='flex-1'>{item.quantity}</td>
                                    <td className='flex-1'>{item.sellingPrice * item.quantity}</td>
                                    <td className='flex-1'>{(item.sellingPrice * item.quantity)- (item.costPrice * item.quantity)}</td>
                                    {/* <td className='flex-1'>{data.protein}</td> */}
                                </tr>
                            ))
                        }
                    </tbody>
                    
                </table>

            </div>
            <div className="flex w-full flex-row-reverse text-secondary2 mt-8">
                {/* button */}
                <ButtonBase
                    aria-label='Delete from history'
                >
                    <div 
                        className="bg-red-500 px-4 py-2 rounded flex text-white"
                        onClick={handleOnDelete}
                    >
                        {!isLoading ? (<BsTrash className='text-white mr-1' />) : (
                            <Loading type="spin" className='mr-1' width="1rem" height="1rem" color="#fff" />
                        )}
                        Delete
                    </div>
                </ButtonBase>
            </div>
        </>
        
    )
    
}